import { render, staticRenderFns } from "./bloquearData.vue?vue&type=template&id=06ac59ac&"
import script from "./bloquearData.vue?vue&type=script&lang=js&"
export * from "./bloquearData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports